import { FieldErrors, FieldValues } from 'react-hook-form';

import NoticeCaption from '../../caption/NoticeCaption';

type Props = {
  id?: string;
  name: string;
  errors?: FieldErrors<FieldValues>;
  description?: React.ReactNode;
  watch?: any;
  maxLength?: number;
  styleWidthSize?: string;
};

export default function Description({
  id,
  name,
  errors,
  description,
  watch,
  maxLength,
  styleWidthSize = 'auto',
}: Props) {
  const error = errors?.[name];
  const hasError = !!error;
  const errorMessage = error?.message?.toString();

  const hasCount = watch && maxLength;
  const watchLength = watch ? (watch(name)?.length ?? 0) : 0; // count 초기값 0

  const showDescription = hasError || description || hasCount;

  if (!showDescription) {
    return <></>;
  }

  return (
    <div
      id={id}
      className="flex flex-row items-start justify-between gap-3 pt-1 [&_[class*='description__message']]:[word-break:normal]"
      style={{ width: styleWidthSize }}
    >
      <span>
        {/* error 메세지 */}
        {errorMessage && (
          <NoticeCaption
            type="error"
            text={errorMessage}
            showBadgeIcon
            className="description__message--error"
          />
        )}

        {/* description 메세지 */}
        {!hasError && description && (
          <NoticeCaption
            type="default"
            text={description}
            showBadgeIcon
            className="description__message--default"
          />
        )}
      </span>

      {/* count - 입력받은 글자 수 */}
      {hasCount && (
        <p
          className={`text-right text-sm font-normal leading-[150%] ${
            hasError ? 'text-apps-coreProductError01' : 'text-apps-coreGray02'
          }`}
        >
          {watchLength}/{maxLength}
        </p>
      )}
    </div>
  );
}
